import { Button } from "@mui/material";
import { ConfiguredAccounts, type ConfiguredAccountsProps } from "./ConfiguredAccounts";

export function MainConfigScreen({
  onAddSource,
  ...configuredAccountsProps
}: ConfiguredAccountsProps & {
  readonly onAddSource: () => void;
}): JSX.Element {
  return (
    <>
      <ConfiguredAccounts {...configuredAccountsProps} />
      <Button className="my-4" variant="contained" onClick={onAddSource}>
        Add New Power BI Account
      </Button>
    </>
  );
}
